export default {
  "content": "<circle cx=\"16\" cy=\"16\" r=\"16\" fill=\"#CEF6E9\"/><path d=\"M18.32 20.006l2.479 4.295m-8.293-5.253l7.74-4.468M10.203 11.34l4.667-2.694m6.245 5.43l-.725.418L14.8 8.69l.072-.042a1.332 1.332 0 00.147-2.209 1.332 1.332 0 00-1.477-.094L8.874 9.04a1.332 1.332 0 00-.491 1.819 1.332 1.332 0 001.82.484l.072-.042 2.232 7.747-.725.419a1.306 1.306 0 00-.481 1.784l.409.708a1.306 1.306 0 001.785.475l9.335-5.389a1.307 1.307 0 00.481-1.784l-.409-.708a1.306 1.306 0 00-1.786-.476z\" stroke=\"#1D1D1B\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>",
  "attrs": {
    "width": "32",
    "height": "32",
    "viewBox": "0 0 32 32",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};